import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import {
  WasteCollectionAreaService,
  WasteCollectionScheduleEntryService,
  WasteNotificationSubscriptionService
} from '../../openapi';
import {
  loadCollection,
  loadCollectionFailure,
  loadCollectionSuccess,
  loadScheduleEntries,
  loadScheduleEntriesFailure,
  loadScheduleEntriesSuccess
} from '../actions/municipal-waste.actions';
import { concatMap, map, of, switchMap, withLatestFrom } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { selectCollection } from '../selectors/municipal-waste.selectors';

@Injectable()
export class MunicipalWasteEffects {
  constructor(
    private actions$: Actions,
    private store$: Store,
    private wasteService: WasteCollectionAreaService,
    private scheduleService: WasteCollectionScheduleEntryService,
    private wasteNotificationSubscriptionService: WasteNotificationSubscriptionService
  ) {
  }

  loadCollection$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadCollection),
      withLatestFrom(this.store$.select(selectCollection)),
      concatMap(([action, collection]) =>
        ((collection.length && !action?.force) ? of(collection) : this.wasteService.getWasteCollectionAreaCollectionWasteCollectionAreaCollection({
          pagination: false
        })).pipe(
          map(collection => loadCollectionSuccess({ collection })),
          catchError(() => of(loadCollectionFailure()))
        )
      )
    )
  );

  loadScheduleEntries$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadScheduleEntries),
      switchMap(action =>
        this.scheduleService.getWasteCollectionScheduleEntryCollectionWasteCollectionScheduleEntryCollection({
          pagination: false,
          area: action.areaId
        }).pipe(
          map((scheduleCollection) => loadScheduleEntriesSuccess({ scheduleCollection })),
          catchError(() => of(loadScheduleEntriesFailure()))
        )
      )
    )
  );

}
